import React from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { motion } from 'framer-motion'

import { Box, ChevronUpIcon } from '@hivewatch/dark'

import { getNotificationsTabTokens } from '../styles/tokens'

// Fills and centres a chevron inside an absolutely-positioned animation layer.
const LAYER_STYLE: React.CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  position: 'absolute',
  width: '100%',
}

export const DrawerToggleButton = ({ isOpen }: { isOpen: boolean }) => {
  const colorScheme = useLightMode()
  const tokens = getNotificationsTabTokens(colorScheme)

  return (
    // ChevronUpIcon defaults to `currentColor`, so the Box's color token themes
    // both chevrons in light and dark mode.
    <Box
      color={tokens.icon}
      data-testid='notificationsTab_drawerToggleButton'
      height='32px'
      position='relative'
      role='button'
      width='32px'
    >
      <motion.div
        animate={{ rotateX: isOpen ? 180 : 0, translateY: isOpen ? '-10%' : 0 }}
        style={LAYER_STYLE}
        transition={{ duration: 0.2 }}
      >
        <ChevronUpIcon height={20} width={20} />
      </motion.div>
      <motion.div
        animate={{ translateY: isOpen ? '10%' : 0 }}
        style={LAYER_STYLE}
        transition={{ duration: 0.2 }}
      >
        <ChevronUpIcon height={20} width={20} />
      </motion.div>
    </Box>
  )
}
